import { facedBits, KEY, run, tap, type Track } from "./inputTrack";
import type { Scenario } from "./scenario";

/**
 * Бой человеком по записи нажатий на 20 с (GAME-31), не ботом: шаг и бег с ударами на ходу, подкаты, прыжки,
 * блок, присед, серии. Обе записи — как у живых игроков: «вперёд» — к сопернику, с какой бы стороны он ни был.
 */
const { F, B, D, U, P, HP, K, HK, BL } = KEY;

const FIRST: Track = [
  [40, 92, F],
  tap(58, F | P),
  tap(76, F | P),
  [92, 112, B],
  ...run(115, 150),
  tap(142, F | K),
  tap(176, U | F),
  tap(190, K),
  [222, 282, F],
  tap(238, F | K),
  tap(262, F | HK),
  [292, 332, BL],
  [342, 384, D],
  tap(350, D | P),
  tap(372, D | HK),
  ...run(400, 436),
  tap(428, F | HK),
  [462, 522, F],
  tap(478, F | P),
  tap(484, F | P),
  tap(490, F | HP),
  [540, 582, B],
  tap(556, B | K),
  tap(602, U | F),
  tap(616, HK),
  ...run(680, 726),
  tap(716, F | P),
  [780, 812, D],
  tap(800, D | HP),
  [850, 1000, F],
  tap(870, F | P),
  tap(900, F | K),
  tap(940, F | HK),
  ...run(1004, 1046),
  tap(1038, F | K),
  [1080, 1200, F],
  tap(1100, F | P),
  tap(1106, F | P),
  tap(1112, F | HP),
  tap(1160, F | HK),
];

const SECOND: Track = [
  [44, 70, F],
  tap(64, F | K),
  [86, 130, BL],
  [130, 170, F],
  tap(150, F | HP),
  tap(186, BL),
  [186, 214, BL],
  ...run(236, 266),
  tap(258, F | K),
  [300, 340, F],
  tap(318, F | P),
  tap(324, F | P),
  tap(330, F | HP),
  [356, 398, BL],
  tap(410, U | B),
  [440, 470, D],
  tap(452, D | HP),
  [500, 540, F],
  tap(520, F | HK),
  ...run(590, 626),
  tap(618, F | HK),
  [660, 700, B],
  tap(676, B | P),
  [730, 790, F],
  tap(748, F | K),
  tap(770, F | P),
  [820, 860, BL],
  tap(880, U | F),
  tap(894, HK),
  [930, 990, F],
  tap(950, F | HP),
  tap(974, F | K),
  [1010, 1050, D],
  tap(1030, D | HK),
  ...run(1070, 1110),
  tap(1100, F | P),
  [1130, 1190, F],
  tap(1146, F | K),
  tap(1170, F | HK),
];

export const HUMAN_FIGHT: Scenario = {
  caption: "Бой по записи нажатий двух людей: шаг, бег, удары на ходу, подкаты, прыжки, блок",
  setup: () => undefined,
  input: (frame, state) => [
    facedBits(FIRST, frame, state.fighters[0].facing),
    facedBits(SECOND, frame, state.fighters[1].facing),
  ],
};
